import { render, staticRenderFns } from "./CurrentTime.vue?vue&type=template&id=3ea3e5df&lang=pug"
import script from "./CurrentTime.vue?vue&type=script&lang=js"
export * from "./CurrentTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports